import { Component, OnDestroy, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Subscription } from 'rxjs'
import { EventService } from '../../services/event.service'
import { RouterService } from '../../services/router.service'
import { ExternalInputService } from '../../services/external-input.service'
import { ActivatedRoute } from '@angular/router'
import { LogService } from 'htv-lib'
import { TranslateModule } from '@ngx-translate/core'
import { HTVPlatform } from '../../platforms/platform'
import { PlatformService } from '../../platforms/platform.service'

@Component({
  selector: 'app-hdmi-not-found',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './hdmi-not-found.component.html',
  styleUrls: ['./hdmi-not-found.component.scss'],
})
export class HdmiNotFoundComponent implements OnInit, OnDestroy {
  platformType!: HTVPlatform
  eventSubscription?: Subscription
  hdmiPort = 0
  hdmiConnected = false
  requestInterval: any
  requestTime = 10

  constructor(
    private eventService: EventService,
    private externalInputService: ExternalInputService,
    private activatedRoute: ActivatedRoute,
    private routerService: RouterService,
    private logService: LogService,
    private platformService: PlatformService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.platformType = this.platformService.type
    this.activatedRoute.queryParams.subscribe(params => {
      this.hdmiPort = params['hdmiPort']
    })
    this.hdmiConnected = this.externalInputService.isHDMIAvailable(this.hdmiPort)
    this.logService.info(`HDMI ${this.hdmiPort} connected: ${this.hdmiConnected}`)

    this.registerEventListener()
    this.registerRequestTimer()
  }

  ngOnDestroy(): void {
    this.cancelRequestTimer()
    this.eventSubscription?.unsubscribe()
  }

  registerEventListener(): void {
    this.eventSubscription = this.eventService.keyDown.subscribe((key: string) => {
      switch (key) {
        case 'BACK':
          this.routerService.goBack()
          break
        default:
          break
      }
    })
  }

  cancelRequestTimer(): void {
    if (this.requestInterval) {
      clearInterval(this.requestInterval)
    }
  }

  registerRequestTimer(): void {
    this.cancelRequestTimer()
    let count = 0
    this.requestInterval = setInterval(() => {
      count++
      this.requestTime = 10 - count
      if (count == 10) {
        this.checkHDMIAvailable()
        count = 0
      }
    }, 1000)
  }

  async checkHDMIAvailable(): Promise<void> {
    // Tizen has no external input listener so we manually reload inputs
    if (this.platformType === HTVPlatform.TIZEN) {
      await this.externalInputService.load()
    }

    this.hdmiConnected = this.externalInputService.isHDMIAvailable(this.hdmiPort)
    if (this.hdmiConnected) {
      this.externalInputService.showHDMI(this.hdmiPort)
    }
  }

  goBack(): void {
    this.routerService.goBack()
  }
}
